export const ISSUE_PARENT_FIELD_TEST_ID =
	'software-board.board-container.board.card-container.card.issue-parent-field.parent-field-lazy';

export const ISSUE_PARENT_FIELD_WRAPPER_TEST_ID =
	'software-board.board-container.board.card-container.card.issue-parent-field.parent-field-wrapper';
